import React, { useState, useEffect } from 'react';

const CreeperRunner = ({ reduceMotion }) => {
  const [position, setPosition] = useState(-100); // Start off-screen
  const [status, setStatus] = useState('walking'); // 'walking', 'hissing', 'exploding', 'hidden'

  useEffect(() => {
    if (status !== 'walking') return;

    const interval = setInterval(() => {
      setPosition((prev) => {
        const width = window.innerWidth;
        if (prev > width + 100) {
          // Off screen, reset and hide for a random delay
          clearInterval(interval);
          setStatus('hidden');
          return -100;
        }
        return prev + 3; // Walk speed
      });
    }, 30);

    return () => clearInterval(interval);
  }, [status]);

  // Handle spawn cycle when hidden
  useEffect(() => {
    if (status !== 'hidden') return;

    // Wait between 5 to 12 seconds to spawn a new creeper
    const delay = Math.random() * 7000 + 5000;
    const timeout = setTimeout(() => {
      setPosition(-100);
      setStatus('walking');
    }, delay);

    return () => clearTimeout(timeout);
  }, [status]);

  const handleMouseEnter = () => {
    if (status === 'walking') {
      setStatus('hissing');
      // Flashing timer
      setTimeout(() => {
        setStatus('exploding');
        // Explosion puff display timer
        setTimeout(() => {
          setStatus('hidden');
          setPosition(-100);
        }, 800);
      }, 1200);
    }
  };

  if (reduceMotion) return null;
  if (status === 'hidden') return null;

  return (
    <div
      className="fixed bottom-0 z-45 select-none pointer-events-auto transition-transform duration-100"
      style={{
        left: `${position}px`,
        transform: `translateY(-16px)`
      }}
      onMouseEnter={handleMouseEnter}
    >
      {status === 'hissing' && (
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-[#e00] text-white border-2 border-black px-2 py-0.5 text-xs font-bold font-mono tracking-wider animate-bounce">
          HSSSS!...
        </div>
      )}

      {status === 'exploding' && (
        <div className="absolute -top-16 -left-8 w-32 h-32 flex items-center justify-center">
          {/* Explosion Cloud Pixel Art */}
          <svg width="80" height="80" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="animate-ping">
            <rect x="4" y="4" width="8" height="8" fill="#ffffff" />
            <rect x="2" y="2" width="12" height="12" fill="#d0d0d0" opacity="0.8" />
            <rect x="6" y="1" width="4" height="14" fill="#a0a0a0" opacity="0.6" />
            <rect x="1" y="6" width="14" height="4" fill="#808080" opacity="0.6" />
            <rect x="5" y="5" width="6" height="6" fill="#ff5555" opacity="0.5" />
          </svg>
          <div className="absolute bg-white text-red-600 font-extrabold border-2 border-black px-2 py-0.5 text-sm font-mono tracking-widest uppercase">
            BOOM!
          </div>
        </div>
      )}

      {status !== 'exploding' && (
        <svg
          width="48"
          height="72"
          viewBox="0 0 16 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="image-rendering-pixelated cursor-pointer"
        >
          {/* Creeper Head */}
          <rect
            x="4"
            y="0"
            width="8"
            height="8"
            fill={status === 'hissing' ? '#ffffff' : '#4eb038'}
            className={status === 'hissing' ? 'creeper-flash-active' : ''}
          />
          {/* Eyes and Mouth details */}
          <rect x="5" y="2" width="2" height="2" fill="#1b1b1b" />
          <rect x="9" y="2" width="2" height="2" fill="#1b1b1b" />
          <rect x="7" y="4" width="2" height="3" fill="#1b1b1b" />
          <rect x="6" y="5" width="1" height="3" fill="#1b1b1b" />
          <rect x="9" y="5" width="1" height="3" fill="#1b1b1b" />

          {/* Body */}
          <rect
            x="6"
            y="8"
            width="4"
            height="10"
            fill={status === 'hissing' ? '#ffffff' : '#3c8e27'}
            className={status === 'hissing' ? 'creeper-flash-active' : ''}
          />
          <rect x="7" y="10" width="2" height="4" fill={status === 'hissing' ? '#ffffff' : '#2f751d'} />

          {/* Bobbing Legs */}
          {/* Front Left leg */}
          <g className={status === 'walking' ? 'creeper-leg-l' : ''}>
            <rect
              x="4"
              y="18"
              width="4"
              height="6"
              fill={status === 'hissing' ? '#ffffff' : '#4eb038'}
              className={status === 'hissing' ? 'creeper-flash-active' : ''}
            />
            <rect x="4" y="22" width="4" height="2" fill="#1b1b1b" />
          </g>
          {/* Front Right leg */}
          <g className={status === 'walking' ? 'creeper-leg-r' : ''}>
            <rect
              x="8"
              y="18"
              width="4"
              height="6"
              fill={status === 'hissing' ? '#ffffff' : '#3c8e27'}
              className={status === 'hissing' ? 'creeper-flash-active' : ''}
            />
            <rect x="8" y="22" width="4" height="2" fill="#1b1b1b" />
          </g>
        </svg>
      )}
    </div>
  );
};

export default CreeperRunner;
